import { ReportCategoryDetail } from './ReportCategoryDetail'
import { withReportCategoryDetail } from './withReportCategoryDetail'

const ConnectedReportCategoryDetail =
  withReportCategoryDetail(ReportCategoryDetail)

export { ConnectedReportCategoryDetail as ReportCategoryDetail }
